import React, { useEffect, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemIcon, IconButton, makeStyles } from '@material-ui/core';
import { EditTwoTone } from '@material-ui/icons';
import ShowProgress from '../ui/Backdrop';
import Check from '../../assets/SvgCheck';
import AddSource from './AddSource';
import Image from '../common/Image';
import Theme from '../ui/Theme';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px',
    height: 'auto',
    backgroundColor: 'white !important',
  },
  listText: {
    flexGrow: 1,
    marginLeft: '16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listTextSelected: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '17px',
  },
  listTextNonSelected: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17px',
  },
  listSubTextSelected: {
    color: Theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: 500,
  },
  highlightItemLeft: {
    borderLeft: `4px solid ${Theme.palette.primary.main}`,
  },
  image: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    marginLeft: '16px',
  },
  check: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
  },
}));

export default function InstructorAssignCardDaily({ instrlist, checkedInstrList, setCheckedInstrList, doseType }) {
  const classes = useStyles();
  const [openEditSource, setOpenEditSource] = useState(false);
  const [selectedInstr, setSelectedInstr] = useState(0);

  useEffect(() => {
    console.log('checked', checkedInstrList);
  }, [checkedInstrList]);
  const handleCloseEditSource = () => {
    setOpenEditSource(false);
  };

  const handleListItemClick = (id) => {
    setCheckedInstrList((prev) =>
      checkedInstrList?.includes(id) ? prev?.filter((item) => item !== id) : [...prev, id],
    );
  };

  return (
    <div className={classes.root} style={{ height: '100%', overflow: 'auto', marginTop: '16px' }}>
      <List component="nav" aria-label="secondary mailbox folder">
        {instrlist.map((data) => (
          <div key={data.id} className={checkedInstrList?.includes(data.id) ? classes.highlightItemLeft : ''}>
            <ListItem
              key={data.id}
              button
              selected={checkedInstrList.includes(data.id)}
              className={classes.listItem}
              onClick={() => handleListItemClick(data.id)}
            >
              <ListItemIcon>{checkedInstrList?.includes(data.id) && <Check className={classes.check} />}</ListItemIcon>
              <ListItemIcon>
                <Image alt="logo" src={data.thumbnail} className={classes.image} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <div className={classes.listText}>
                    <span
                      className={
                        checkedInstrList?.includes(data.id) ? classes.listTextSelected : classes.listTextNonSelected
                      }
                    >
                      {data.name}
                    </span>
                  </div>
                }
                secondary={
                  <div>
                    <div className={classes.listSubTextSelected}></div>
                  </div>
                }
              />
              <IconButton
                edge="end"
                aria-label="edit"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedInstr(data.id);
                  setOpenEditSource(true);
                }}
              >
                <EditTwoTone />
              </IconButton>
            </ListItem>
          </div>
        ))}
      </List>
      {<ShowProgress />}
      {openEditSource && (
        <AddSource
          open
          edit
          type="instructor"
          selId={selectedInstr}
          doseType={doseType}
          close={handleCloseEditSource}
        />
      )}
    </div>
  );
}
